import { Button, Heading } from '@mm/components';
import { OpenActivateChannelsModalParams } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import Spinner from '../../components/Spinner';
import { useBotChannels } from '../../hooks/use-bot-channels';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './ActivateChannelsModal.pcss';

type Props = OpenActivateChannelsModalParams & {
  closeModal: () => void;
  onClose?: () => void;
};

const ActivateChannelsModal = ({
  channels,
  onSuccess = () => {},
  onReject = () => {},
  closeModal,
}: Props) => {
  const { busy, toggleChannels, formatChannelName } = useBotChannels();
  const emailChannel = channels?.indexOf('email') > -1;

  const handleCloseModal = () => {
    closeModal();
    onReject();
  };

  const onActivateClick = async () => {
    const [err] = await toggleChannels(channels, true);

    if (err) {
      return onReject(err);
    }

    closeModal();
    onSuccess();
  };

  return (
    <div>
      <ModalHeader closeOverride={handleCloseModal}>
        <Heading size={4}>Activate channels</Heading>
      </ModalHeader>

      <ModalBody>
        {busy && <Spinner standalone />}

        {!busy && (
          <>
            <Heading size={4} isBold={false}>
              These channels need to be activated:
              <Heading size={4}>
                {channels.map(formatChannelName).join(', ')}
              </Heading>
            </Heading>
            {emailChannel && (
              <Heading size={4} isBold={false} addMarginAbove>
                Add an email account via the Integrations link on the top menu.
              </Heading>
            )}
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          onClick={handleCloseModal}
          color="secondary-blue"
          disabled={busy}
        >
          Cancel
        </Button>

        <Button
          onClick={onActivateClick}
          color="green"
          disabled={busy || emailChannel}
        >
          Activate
        </Button>
      </ModalFooter>
    </div>
  );
};

export default ActivateChannelsModal;
